import { tss } from 'tss-react/mui';

import type { ThemeMode } from '@/types/theme';

const useStyles = tss
  .withParams<{
    isLayoutMobile?: boolean;
    themeMode: ThemeMode;
  }>()
  .create(({ theme, themeMode }) => {
    return {
      login: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        paddingTop: 'min(20vh, 20vw)',
        background:
          themeMode === 'dark'
            ? 'linear-gradient(to bottom, #201f21 0%, #0e2a52 100%)'
            : '#fff'
      },
      logo: {
        marginLeft: '-9rem',
        [theme.breakpoints.down('md')]: {
          marginLeft: '-4.5rem'
        }
      },
      wrapper: {
        position: 'relative',
        zIndex: 2,
        padding: '2rem',
        [theme.breakpoints.down('md')]: {
          padding: '0 2rem 2rem 6rem'
        }
      },
      title: {
        color: theme.vars.palette.text.primary,
        fontWeight: 400,
        letterSpacing: '.02rem',
        [theme.breakpoints.down('md')]: {
          span: {
            display: 'block'
          }
        }
      },
      button: {
        marginTop: '2rem'
      }
    };
  });

export default useStyles;
